export default area => {
	if (area) {
		return area.title + (area.subtitle ? ` ${area.subtitle}` : '');
	}

	return '';
};
